import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import type { IconComponent } from '../Icon/createIcon';
import type { IconSize } from '../Icon/types';

import { Styled } from './styles';
import type { HighlightedIconColor } from './types';

export type { HighlightedIconColor } from './types';

type HighlightedIconProps = {
  icon: IconComponent;
  color: HighlightedIconColor;
  size?: IconSize;
};
type SpanProps = Omit<ComponentPropsWithoutRef<'span'>, keyof HighlightedIconProps>;

type Props = SpanProps & HighlightedIconProps;

export const HighlightedIcon = forwardRef<HTMLSpanElement, Props>(
  ({ icon: IconEl, color, size = 'l', ...props }, ref) => (
    <Styled.Container {...props} color={color} ref={ref}>
      <Styled.IconWrapper>
        <IconEl size={size} />
      </Styled.IconWrapper>
    </Styled.Container>
  ),
);
HighlightedIcon.displayName = 'HighlightedIcon';
